// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"52431f51","244":"2cadcd41","537":"c9141315","620":"920313a5","789":"f5ea9e85"}[chunkId] + ".chunk.js";
};